/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespHeroCarousel_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespZoomModal_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
